import type { InputValidation } from '@shared/validation'

export const DATEPICKER_INCOMPLETE_ERROR = 'Please select both a month and day.'

// Blocks submitting a partial GSheetDatepicker on surfaces outside a GForm submit flow.
// The error only displays after a blocked submit attempt (markSubmitAttempt).
export function useDatepickerCompleteness () {
  const incomplete = ref(false)
  const submitAttempted = ref(false)

  function markSubmitAttempt () {
    submitAttempted.value = true
  }

  const validation: InputValidation = {
    isValueValid: () => !(submitAttempted.value && incomplete.value),
    errorMessage: () => DATEPICKER_INCOMPLETE_ERROR,
    immediate: true,
  }

  return { incomplete, markSubmitAttempt, validation }
}
